module.exports = __webpack_public_path__ + "static/media/img_0.29a774b7.png";